function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "40.903%",
  y1: "26.718%",
  x2: "89.258%",
  y2: "87.531%",
  id: "a"
}, React.createElement("stop", {
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#3A3A3A",
  offset: "100%"
})), React.createElement("path", {
  id: "b",
  d: "M0 0h1920v786H0z"
}), React.createElement("linearGradient", {
  x1: "26.175%",
  y1: "73.793%",
  x2: "74.815%",
  y2: "57.211%",
  id: "c"
}, React.createElement("stop", {
  stopColor: "#212020",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#161616",
  offset: "100%"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M0 0h1920v786H0z",
  fill: "url(#a)",
  fillRule: "nonzero"
}), React.createElement("mask", {
  id: "d",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#b"
})), React.createElement("path", {
  fill: "url(#c)",
  fillRule: "nonzero",
  opacity: 0.775,
  mask: "url(#d)",
  transform: "matrix(-1 0 0 1 1091 0)",
  d: "M1091 282L0 785h1091z"
}));

var SvgComponent = function SvgComponent(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: 1920,
    height: 786,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default "data:image/svg+xml;base64,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";
export { SvgComponent as ReactComponent };